import React from 'react';

import Configuration from '@src/configuration';
import Database from '@src/database';
import Firebase from '@src/firebase';
import { LoggerProvider } from '@src/hooks/useLogger';
import I18n from '@src/i18n';
import Navigation from '@src/navigation';
import ServiceWorker from '@src/serviceWorker';
import Store from '@src/store';
import Theme from '@src/theme';

type Props = {
  isHeadless?: boolean;
};

const App: React.FC<Props> = ({ isHeadless }) => {
  return (
    <LoggerProvider>
      <Database>
        <Store>
          <Firebase isHeadless={isHeadless}>
            <Configuration>
              <I18n>
                <Theme>
                  <ServiceWorker>
                    <Navigation />
                  </ServiceWorker>
                </Theme>
              </I18n>
            </Configuration>
          </Firebase>
        </Store>
      </Database>
    </LoggerProvider>
  );
};

export default App;
